import {createAction} from '@reduxjs/toolkit';
import {FilterValue} from 'src/hooks/filtered-data/useFilteredData';
import {Filters} from 'src/modules/events/typedefs';

export const SET_EVENTS_FILTER = 'SET_EVENTS_FILTER';
export const CLEAR_EVENTS_FILTERS = 'CLEAR_EVENTS_FILTERS';
export const SET_ALL_EVENTS_FILTERS = 'SET_ALL_EVENTS_FILTERS';

export const setAllEventsFilters = createAction<Filters>(SET_ALL_EVENTS_FILTERS);

export const setEventsFilter = createAction<{filterType: string, filterValue: FilterValue}>(SET_EVENTS_FILTER);

export const clearEventsFilters = createAction(CLEAR_EVENTS_FILTERS);
